export default "__VITE_ASSET__B9kG4sB9__"